// La nouvelle interface, épurée (9 octobre 2026) : la coquille.
export default {
  nav: {
    aria: 'Navigation principale',
    veille: 'Veille',
    formats: 'Formats',
    reglages: 'Réglages',
    replier: 'Replier la navigation',
    deplier: 'Déplier la navigation',
    ouvrir: 'Ouvrir la navigation',
    fermer: 'Fermer la navigation',
  },
  theme: {
    sombre: 'Sombre',
    clair: 'Clair',
  },
  pagination: {
    resume: '{debut} à {fin} sur {total}',
    precedente: 'Page précédente',
    suivante: 'Page suivante',
    page: 'Page {n}',
  },
}
